export default "__VITE_ASSET__dS1kvVtS__"